import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Clock, ArrowRight } from 'lucide-react';

/**
 * TrialBanner - Shows a banner for users in trial period
 * 
 * Displays remaining trial days and prompts to upgrade
 */
const TrialBanner = () => {
  const { subscription, isInTrial, getTrialDaysRemaining } = useAuth();

  // Only show for trial users
  if (!isInTrial()) {
    return null;
  }

  const daysRemaining = getTrialDaysRemaining();
  const isUrgent = daysRemaining <= 1;

  return (
    <div className={`w-full py-2 px-4 text-center text-sm ${
      isUrgent 
        ? 'bg-red-600 text-white' 
        : 'bg-blue-600 text-white'
    }`}>
      <div className="flex items-center justify-center gap-2 flex-wrap">
        <Clock className="w-4 h-4" />
        <span>
          {isUrgent 
            ? 'Je proefperiode eindigt vandaag!' 
            : `Je proefperiode eindigt over ${daysRemaining} ${daysRemaining === 1 ? 'dag' : 'dagen'}`
          }
        </span>
        <Link 
          to="/company/subscription" 
          className={`inline-flex items-center gap-1 font-medium underline hover:no-underline ${
            isUrgent ? 'text-white' : 'text-blue-100 hover:text-white'
          }`}
        >
          Upgrade nu <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
    </div>
  );
};

export default TrialBanner;
